/**
 * Simppeli keydown-eventin bindaus suoraan elementistä.
 */
app.directive('onKeydown', ["$rootScope", "$parse", function($rootScope, $parse) {

	return {

		restrict: 'A',
		link: function(scope, element, attrs) {
			if(attrs.onKeydown) {

				var callback = $parse(attrs.onKeydown);
				$(element).on('keydown', function(e) {
					scope.$apply(function() {
						callback(scope, {
							event: e
						});
					});

				});
			}
		},

		controller: ["$scope", function($scope) {

		}]
	};

}]);

